import tippy from 'tippy.js'
export const initTooltips = () => {
    tippy('[data-tippy-content]', {
        allowHTML: true,
        placement: 'top-end',
        maxWidth: 270,
        offset: ({ placement, reference, popper }) => {
            switch (placement) {
                case 'top-start':
                case 'bottom-start':
                    return [-11, 20]
                case 'top-end':
                case 'bottom-end':
                    return [11, 20]
                default:
                    return [0, 20]
            }
        },
        trigger: 'click focusin mouseenter',
        //trigger: 'click',
        arrow: false,
        interactive: true,
        onUntrigger(instance, event) {
            event.preventDefault()
        },
        onTrigger(instance, event) {
            event.preventDefault()
        },
    })
}